import {
  StorageBreadcrumbViewModel,
  StorageCurrentFolderViewModel,
  StorageFileAction,
  StorageFileViewModel,
  StorageFolderViewModel,
} from '../../models/Entities/AzureFiles/StorageBrowser';
import { ErrorType } from '../../models/HttpError';
import { StorageEntityNameEntry } from '../../functions/StorageBrowser.Functions';

export interface StorageBrowserState {
  /** Folder being shown, relative to the tenant root ("" = root) */
  currentPath: string;
  breadcrumbs: StorageBreadcrumbViewModel[];
  folders: StorageFolderViewModel[];
  files: StorageFileViewModel[];
  continuationToken: string | null;
  /** Capabilities of the current folder (canUpload / canCreateFolder / allowedExtensions); null until known */
  currentFolder: StorageCurrentFolderViewModel | null;
  isLoading: boolean;
  isLoadingMore: boolean;
  /** true once the current path answered at least once */
  isLoaded: boolean;
  error: ErrorType | undefined;
  /** File whose SAS is being requested */
  pendingFile: { path: string; action: StorageFileAction } | undefined;
  /** Last open/download error */
  fileError: { path: string; action: StorageFileAction; error: ErrorType } | undefined;
  /** Protocol / settlement / provider / sponsor names resolved by id, keyed by getEntityNameKey */
  entityNames: Record<string, StorageEntityNameEntry>;
}

export const StorageBrowserUnloadedState: StorageBrowserState = {
  currentPath: '',
  breadcrumbs: [],
  folders: [],
  files: [],
  continuationToken: null,
  currentFolder: null,
  isLoading: false,
  isLoadingMore: false,
  isLoaded: false,
  error: undefined,
  pendingFile: undefined,
  fileError: undefined,
  entityNames: {},
};
